import * as React from "react";
const SvgGitBranch = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 512 512", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("title", null, "ionicons-v5-d"), /* @__PURE__ */ React.createElement("circle", { cx: 160, cy: 96, r: 48, style: {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 32
} }), /* @__PURE__ */ React.createElement("circle", { cx: 160, cy: 416, r: 48, style: {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 32
} }), /* @__PURE__ */ React.createElement("line", { x1: 160, y1: 368, x2: 160, y2: 144, style: {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 32
} }), /* @__PURE__ */ React.createElement("circle", { cx: 352, cy: 160, r: 48, style: {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 32
} }), /* @__PURE__ */ React.createElement("path", { d: "M352,208c0,128-192,48-192,160", style: {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 32
} }));
export default SvgGitBranch;
